module.exports = __webpack_public_path__ + "img/icon_battery.ea2f0f3b.svg";